import React from 'react'
import { Difference } from './Difference'
import differencesCategoryMapper from '../utils/differenceCategoryMapper'

export const SpotDiffOverlay = ({ spots, differences }) => {
  return (
    <div
      style={{
        zIndex: '1',
        position: 'absolute',
        top: '0',
        width: '100%',
        height: '100%',
      }}
    >
      {spots.map(spot => (
        <div
          key={spot.id}
          className={`spot ${spot.isCorrect ? 'correct' : 'incorrect'}`}
          style={{
            top: `${spot.y}%`,
            left: `${spot.x}%`,
            width: `${spot.radius}px`,
            height: `${spot.radius}px`,
          }}
        />
      ))}
      {differences.map(
        ({ id, userFound, notFoundInTime, top, left }) =>
          (userFound || notFoundInTime) && (
            <Difference
              key={id}
              onImage
              type={differencesCategoryMapper({
                notFoundInTime,
                userFound,
              })}
              style={{
                position: 'absolute',
                top: `${top}%`,
                left: `${left}%`,
              }}
            />
          ),
      )}
    </div>
  )
}
